(function() {
    angular
        .module('app')
        .directive('searchBucketList',searchBucketList);

    function searchBucketList(){

        return {
            restrict: 'E',
            templateUrl :'app/directives/searchBucketList/searchBucketList.html',
            scope: {
                buckets: '=',
                setBucket: '='
            },
            link: function (scope, el, attrs) {

            }
        }
    }
})();